module.exports = __webpack_public_path__ + "static/flags/BY-0b6935d36b43ad2ba624017ba5692e28.gif";